export class ValidationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ValidationError';
  }
}

/** GraphQLのエラーでres.dataがnullの場合の発生するエラー */
export class DataNotExistError extends Error {}
